import ActionAlert from './ActionAlert';

export default ActionAlert;
